import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default ({ component: C, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      !cProps.user.role ? <C {...props} {...cProps} /> : <Redirect to="/home" />
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/router/UnauthenticatedRoute.js